import React from "react";
import {ReportsMainPageChart} from "../reports-main-page-chart/reports.main.page.chart";

export const ReportsMainPageSales: React.FC = () => (
    <section className="reports-main-page__overview">
        <ReportsMainPageChart />
    </section>
);
